import { Link } from "react-router-dom";
import { Globe } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";

// Banner de obrigatoriedade de domínio: revendedores novos (domain_required) sem domínio configurado.
export function DomainGate() {
  const { user } = useAuth();
  const { t } = useLang();
  if (!user || user.role !== "reseller" || !user.domain_required || (user.custom_domain || "").trim()) return null;
  return (
    <div data-testid="domain-gate-banner" className="rounded-2xl border border-amber-400/40 bg-amber-400/10 p-4 flex flex-col sm:flex-row sm:items-center gap-3">
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <Globe size={18} className="text-amber-300 shrink-0" />
        <p className="text-xs text-amber-200 leading-relaxed">{t("gate_domain")}</p>
      </div>
      <Link data-testid="domain-gate-btn" to="/app/settings" className="btn-neon px-4 py-2 rounded-lg text-xs font-bold shrink-0 text-center">
        {t("gate_domain_btn")}
      </Link>
    </div>
  );
}
